import { useAuth } from './auth-context'

/**
 * Роль в активной организации, а не глобальные права (для них — usePermissions).
 * Часть эндпоинтов организации (инвайты, транзакции токенов, изменение названия)
 * отвечает 403 всем, кроме admin, — по этому признаку такие запросы не отправляем.
 */
export function useIsOrganizationAdmin(): boolean {
  const { user } = useAuth()

  return user?.organization_role === 'admin'
}
